import script from "./ToggleBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleBtn.vue?vue&type=script&setup=true&lang=js"

import "./ToggleBtn.vue?vue&type=style&index=0&id=1f1bb8f4&lang=scss"

const __exports__ = script;

export default __exports__